<template>
  <div class="root">
    <span
      v-for="(route, index) in list"
      :key="route.name"
    >
      <router-link
        v-if="index != list.length - 1"
        :to="{name: route.name === 'main'? 'home': route.name}"
        class="menu1"
      >{{ route.meta.menu.label }}</router-link>
      <span v-if="index == list.length - 1">{{ route.meta.menu.label }}</span>
      <fa-icon
        v-if="index != list.length - 1"
        class="arrow"
        icon="chevron-right"
      />
    </span>
  </div>
</template>
<script>
export default {
  computed: {
    list: function() {
      return this.$route.matched.filter(route => {
        return route && route.meta && route.meta.menu && route.meta.menu.label
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../assets/lib.less";
.root{
  position: sticky;
  left: 0;
  top: 0;
  z-index: 9;
  background-color: #f2f2f2;
}
.phone_only {
  .root {
    font-size: 24/@rem;
    padding: 24/@rem;
    .arrow {
      padding: 0 16/@rem;
      font-size: 22/@rem;
    }
    a {
      text-decoration: none;
      color: #333;
    }
  }
}
.pc_only {
  .root {
    font-size: 12px;
    padding: 8px 20px;
    .arrow {
      padding: 0 10px;
      font-size: 10px;
    }
    a {
      text-decoration: none;
      color: #333;
    }
  }
}
</style>
